(function() {
  'use strict';

  function initFilter(root) {
    if (!root || root._inited) return;
    root._inited = true;

    const hiddenInputs = {
      sort: root.querySelector('input[name="filter_sort"]'),
      tag: root.querySelector('input[name="filter_tag"]'),
      year: root.querySelector('input[name="filter_year"]')
    };

    // 初始化：不设置任何选中状态，保持默认样式
    // 注意：不设置 aria-current，避免显示选中样式

    function closeAll() {
      root.querySelectorAll('.component-filter__item').forEach(function(item){
        const btn = item.querySelector('.component-filter__state-layer');
        const dd = item.querySelector('.component-filter__dropdown');
        if (btn) {
          btn.setAttribute('aria-expanded', 'false');
        }
        if (dd) dd.hidden = true;
      });
    }

    root.querySelectorAll('.component-filter__item').forEach(function(item){
      const control = item.getAttribute('data-filter-control');
      const btn = item.querySelector('.component-filter__state-layer');
      const dd = item.querySelector('.component-filter__dropdown');
      const current = item.querySelector('[data-current]');
      if (!btn || !dd) return;

      btn.addEventListener('click', function(e){
        e.stopPropagation();
        const wasExpanded = btn.getAttribute('aria-expanded') === 'true';
        const shouldExpand = !wasExpanded;
        
        // 先关闭所有下拉
        closeAll();
        
        // 如果之前是关闭的，现在打开；如果之前是打开的，现在保持关闭
        if (shouldExpand) {
          btn.setAttribute('aria-expanded', 'true');
          dd.hidden = false;
        }
      });

      dd.querySelectorAll('.component-filter__option').forEach(function(opt){
        opt.addEventListener('click', function(){
          const val = opt.getAttribute('data-value');
          const label = opt.textContent.trim();
          if (current) current.textContent = label;
          
          // 清除所有选项的选中状态
          dd.querySelectorAll('.component-filter__option').forEach(function(o){
            o.removeAttribute('aria-current');
          });
          
          // 设置当前选项为选中
          opt.setAttribute('aria-current', 'true');

          if (hiddenInputs[control]) hiddenInputs[control].value = val;
          root.dataset[control] = val;

          closeAll();
          
          // 用户主动点击后，始终显示选中样式（即使是默认选项）
          btn.setAttribute('data-selected', 'true');
          
          root.dispatchEvent(new CustomEvent('filter:change', {
            bubbles: true,
            detail: {
              sort: hiddenInputs.sort ? hiddenInputs.sort.value : '',
              tag: hiddenInputs.tag ? hiddenInputs.tag.value : '',
              year: hiddenInputs.year ? hiddenInputs.year.value : ''
            }
          }));
        });
      });
    });

    const resetBtn = root.querySelector('[data-reset]');
    if (resetBtn) {
      resetBtn.addEventListener('click', function(e){
        e.stopPropagation(); // 阻止事件冒泡
        
        // 关闭所有打开的下拉菜单
        closeAll();
        
        root.dataset.sort = 'latest';
        root.dataset.tag = 'all';
        root.dataset.year = 'all';
        if (hiddenInputs.sort) hiddenInputs.sort.value = 'latest';
        if (hiddenInputs.tag) hiddenInputs.tag.value = 'all';
        if (hiddenInputs.year) hiddenInputs.year.value = 'all';

        root.querySelectorAll('.component-filter__item').forEach(function(item){
          const control = item.getAttribute('data-filter-control');
          const current = item.querySelector('[data-current]');
          if (control === 'sort') current.textContent = 'Latest';
          if (control === 'tag') current.textContent = 'All Topics';
          if (control === 'year') current.textContent = 'All Year';
          
          // Reset 后清除所有选项的选中状态（包括 aria-current）
          item.querySelectorAll('.component-filter__option').forEach(function(o){
            o.removeAttribute('aria-current');
          });
          
          const btn = item.querySelector('.component-filter__state-layer');
          if (btn) {
            // Reset 后清除选中样式，恢复为初始默认状态
            btn.removeAttribute('data-selected');
          }
        });

        root.dispatchEvent(new CustomEvent('filter:reset', { bubbles: true }));
      });
    }

    document.addEventListener('click', function(e){
      // 检查点击的是否是按钮或下拉菜单内的元素
      const clickedButton = e.target.closest('.component-filter__state-layer');
      const clickedDropdown = e.target.closest('.component-filter__dropdown');
      const clickedWrapper = e.target.closest('.component-filter__wrapper');
      
      // 如果点击的不是按钮、下拉菜单或包装器内的元素，关闭所有下拉
      // 注意：按钮和选项的点击事件都有 stopPropagation，所以不会触发这里
      if (!clickedButton && !clickedDropdown && !clickedWrapper) {
        closeAll();
      }
    });
  }

  function autoInit() {
    document.querySelectorAll('[data-component="filter"]').forEach(initFilter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoInit);
  } else {
    autoInit();
  }

  window.initFilterComponent = autoInit;
})();


